import { css } from "styled-components"

import TextHTML from "./TextHTML"

export const textHTMLStyles = css`
  word-break: break-word;
`

export default TextHTML
